import { render, staticRenderFns } from "./AuthSideRestore.vue?vue&type=template&id=1f68c6e4&scoped=true&"
import script from "./AuthSideRestore.vue?vue&type=script&lang=js&"
export * from "./AuthSideRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f68c6e4",
  null
  
)

export default component.exports